import { translateFn } from '../translate-fn';
import { units } from './unit.enum';

export function unitFormatter(
    unit: {
        name?: string;
        formattedName?: string;
        symbol?: string;
        code?: string;
    } | string,
    qty: number,
    translate: translateFn,
    short = false
): string {
    if (typeof unit === 'string') {
        unit = { code: unit };
    }
    if (isNaN(qty)) {
        qty = 1;
    }
    if (unit?.code && units[unit.code]) {
        if (short) {
            return translate(units[unit.code].short, { count: qty });
        } else {
            return translate(units[unit.code].long, { count: qty });
        }
    } else if (unit.symbol && short) {
        return translate(unit.symbol, { count: qty });
    } else if (unit.formattedName && !short) {
        return translate(unit.formattedName, { count: qty });
    } else if (!short && unit?.name) {
        return translate(unit?.name);
    }

    return '';
}

export function getUnitName(
    unitCode: string,
    translate: translateFn,
) {
    return translate(units[unitCode]?.name) || unitCode;
}

export function getUnitInfo(
    unitCode: string,
) {
    return units[unitCode] ? {
        id: 0,
        code: unitCode,
        name: units[unitCode].name,
        symbol: units[unitCode].short,
        formattedName: units[unitCode].long,
    } : {
        id: 0,
        code: unitCode,
        name: unitCode,
        symbol: unitCode,
        formattedName: unitCode,
    };
}